import React, { Component } from "react";
import "./../lente-pronta.css";
import AppContext from "../../appContext";
import Input from "../../components/inputs/input";
import Select from "../../components/selects/select";
import CnpjUtils from "../../shared/utils/CnpjUtils";

class LenteProntaEtapaUm extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    LenteProntaEtapaUm.contextType = AppContext;
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange({ [event.target.name]: event.target.value });
  }

  handleChangeCnpj = (event) => {
    const clean = CnpjUtils.cleanCnpj(event.target.value).slice(0, 14);
    this.props.onChange({ dados_empresa_faturamento_cnpj: clean });
  }

  handleChangeEmpresa = evt => {
    const { name, value, type } = evt.target;
    let selectedText;
    if (type === "select-one") {
      const selectedIndex = evt.target.selectedIndex;
      selectedText = evt.target?.options?.[selectedIndex]?.text || value;
    } else {
      selectedText = value;
    }

    if (name === "dados_empresa_faturamento_cnpj" && selectedText) {
      const cnpjWithoutMask = CnpjUtils.cleanCnpj(value);
      this.props.onChange({
        otica: {
          nome: selectedText,
          cnpj: value,
          redeOticas: true,
        },
        empresaFaturamento: selectedText,
        dados_empresa_faturamento: selectedText,
        dados_empresa_faturamento_cnpj: cnpjWithoutMask,
      });
    }
  };

  render() {
    const { otica, disableFields, redes = null, dados_empresa_faturamento_cnpj, redeOticas } = this.props;
    let contextAux = this.context;
    const hasSimulacaoLab = contextAux.userSession.modulos.includes("Pedido e Simulação Laboratórios");
    const isEssilor = contextAux.userSession.papelCategoria === "ESSILOR";
    const podeEditarCnpj = hasSimulacaoLab || isEssilor;

    return (
      <div>
        <div className="row">
          <div className="col-12 col-md-4">
            <Input
              name="numeroPedido"
              id="input-numero-pedido"
              type="text"
              label="Nº do pedido da ótica*"
              aria="Preencha nº do pedido"
              width="100%"
              autocomplete="off"
              disabled={disableFields}
              readOnly={disableFields}
              onChange={this.handleChange}
              value={this.props.numeroPedido}
              maxlength="200"
            />
          </div>
          <div className="col-12 col-md-8">
            {podeEditarCnpj && !redeOticas && (
              <Input
                name="dados_empresa_faturamento_cnpj"
                id="input-empresa-faturamento-cnpj"
                type="text"
                label="CNPJ da Empresa de faturamento*"
                aria="Preencha o CNPJ da Empresa de faturamento"
                width="100%"
                autocomplete="off"
                value={CnpjUtils.formatCnpj(dados_empresa_faturamento_cnpj || "")}
                onChange={this.handleChangeCnpj}
                placeholder="XX.XXX.XXX/XXXX-XX"
                maxlength="18"
                disabled={disableFields}
                readOnly={disableFields}
              />
            )}
            {!podeEditarCnpj && (!redeOticas || !contextAux.userSession.redeOticas) && (
              <Input
                name="empresaFaturamento"
                id="input-empresa-faturamento"
                type="text"
                label="Empresa de faturamento*"
                aria="Empresa de faturamento"
                width="100%"
                value={otica.nome || ""}
                readOnly={true}
                disabled={disableFields}
                onChange={this.handleChange}
              />
            )}
            {redeOticas && contextAux.userSession.redeOticas && (
              <Select
                label="Empresa de faturamento*"
                width="100%"
                id="selectEmpresaFaturamento"
                name="dados_empresa_faturamento_cnpj"
                itens={redes}
                value={dados_empresa_faturamento_cnpj || ""}
                onChange={this.handleChangeEmpresa}
                aria="Selecione a Empresa de faturamento"
                placeholder="Selecione a Empresa de faturamento"
                placeholder_dont_display={true}
                required
              />
            )}
          </div>
          {this.props.PossuiProgramaFidelidadeProprio_c && (
            <div className="col-12 col-md-4">
              <Input
                type="number"
                name="codigoParticipante"
                id="input-codigo-participante"
                label="Código do Participante"
                width="100%"
                aria="Código do Participante"
                tooltip="Informe o seu número do programa de fidelidade do laboratório (caso participe)."
                value={this.props.codigoParticipante}
                onChange={this.handleChange}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default LenteProntaEtapaUm;
